
export const getLevelAdvantages = (level, includeCoefficient = false) => {
    switch (level) {
    case 'Silver':
        return [
            'Сувенирка',
            'Техника до 5 тыс. руб.',
            'Товары Apple',
        ];
    case 'Gold': {
        const advantagesGold = [
            'Сувенирка',
            'Техника до 150 тыс. руб.',
            'Подарочные сертификаты на 5 000 руб. : Эльдорадо, М.Видео, ДНС, Ламода, Ozon, Детский мир, Золотое яблоко, Wildberries',
            'Возможность участия в распродажах',
            'Товары Apple',
        ];
        if (includeCoefficient) advantagesGold.unshift('+20% к начислению уралкоинов');
        return advantagesGold;
    }
    case 'Platinum':
    {
        const advantagesPlatinum = [
            'Сувенирка',
            'Техника до 150 тыс. руб.',
            'Подарочные сертификаты до 15 000 руб. : Эльдорадо, М.Видео, ДНС, Ламода, Ozon, Детский мир, Золотое яблоко, Wildberries',
            'Возможность участия в распродажах',
            'Запросы на спец. товары (добавление любого товара в магазин на усмотрение продавца)',
            'Товары Apple',
        ];
        if (includeCoefficient) advantagesPlatinum.unshift('+30% к начислению уралкоинов');
        return advantagesPlatinum;
    }
    default:
        return [];
    }
};

export const getLevelAddedAdvantages = (level) => {
    switch (level) {
    case 'Silver':
        return [
            'Сувенирка',
            'Техника до 5 тыс. руб.',
            'Товары Apple',
        ];
    case 'Gold':
        return [
            'Техника до 150 тыс. руб.',
            'Подарочные сертификаты на 5 000 руб. : Эльдорадо, М.Видео, ДНС, Ламода, Ozon, Детский мир, Золотое яблоко, Wildberries',
            'Возможность участия в распродажах',
        ];
    case 'Platinum':
        return [
            'Подарочные сертификаты до 15 000 руб. : Эльдорадо, М.Видео, ДНС, Ламода, Ozon, Детский мир, Золотое яблоко, Wildberries',
            'Запросы на спец. товары (добавление любого товара в магазин на усмотрение продавца)',
        ];
    default:
        return [];
    }
};
